import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import { getSamplingQueries, OrdersPage } from '@sampling';

export const Route = createFileRoute('/_app/_admin/orders')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(ctx.context.auth, Permission.WipPages);
  },
  loader: async ({ context }) => {
    const queries = getSamplingQueries();
    await context.queryClient.prefetchQuery(
      queries.orders.list({
        page: 1,
        sorting: [],
        filters: [],
      }),
    );
  },
  component: OrdersPage,
});
